import React, { useEffect, useState } from 'react'

import { Button, Card, CardActions, CardContent, CardHeader } from '@mui/material'

import { ConfirmModal } from 'components/_base'
import { useMfaReset } from 'hooks/useMfaReset'

const MfaReset = () => {
  const { mutate: resetMfa, isSuccess } = useMfaReset()
  const [confirmOpen, setConfirmOpen] = useState(false)

  useEffect(() => {
    isSuccess && setConfirmOpen(false)
  }, [isSuccess])

  const handleResetMfaClick = () => setConfirmOpen(true)

  const handleConfirmResetMfa = () => {
    resetMfa()
  }

  return (
    <Card>
      <CardHeader title="Multi-factor Authentication" />
      <CardContent>MFA is already configured. You can reset it if you've lost your authenticator.</CardContent>
      <CardActions>
        <Button color="secondary" onClick={handleResetMfaClick}>
          Reset MFA
        </Button>
      </CardActions>
      <ConfirmModal
        onClose={() => setConfirmOpen(false)}
        onConfirm={handleConfirmResetMfa}
        open={confirmOpen}
        title="Are you sure you want to reset MFA?"
      />
    </Card>
  )
}

export default MfaReset
